export default {
    "table-container": {
        "table-responsive": true
    },
    "table": {
        "table": true,
        "table-striped": true,
        "border": true
    },
    "t-head": {},
    "t-body": {},
    "td": {},
    "th": {}
}